/**
 * Service Package Manager
 * Section 6.1.4 - Edit service packages
 */

import { useState } from 'react';
import pricingConfig from '../../config/pricing_config.json';

function PackageManager() {
  const [packages, setPackages] = useState(pricingConfig.package_includes);
  const [hasChanges, setHasChanges] = useState(false);

  const updatePackage = (category, field, value) => {
    setPackages(prev => ({
      ...prev,
      [category]: {
        ...prev[category],
        [field]: value
      }
    }));
    setHasChanges(true);
  };

  const updateInclude = (category, index, value) => {
    setPackages(prev => ({
      ...prev,
      [category]: {
        ...prev[category],
        includes: prev[category].includes.map((item, i) => i === index ? value : item)
      }
    }));
    setHasChanges(true);
  };

  const addInclude = (category) => {
    setPackages(prev => ({
      ...prev,
      [category]: {
        ...prev[category],
        includes: [...prev[category].includes, 'New item']
      }
    }));
    setHasChanges(true);
  };

  const removeInclude = (category, index) => {
    setPackages(prev => ({
      ...prev,
      [category]: {
        ...prev[category],
        includes: prev[category].includes.filter((_, i) => i !== index)
      }
    }));
    setHasChanges(true);
  };

  const handleSave = () => {
    alert('Save functionality requires backend API (coming in Phase 4)');
  };

  const categoryColors = {
    standard: '#3b82f6',
    european: '#f59e0b',
    truck: '#ef4444'
  };

  return (
    <div className="package-manager">
      <div className="admin-page-header">
        <h1>Service Packages</h1>
        <p>Edit service package details and inclusions</p>
      </div>

      {hasChanges && (
        <div className="unsaved-banner">
          You have unsaved changes
          <button className="admin-btn admin-btn-primary" onClick={handleSave}>
            Save Changes
          </button>
        </div>
      )}

      <div className="packages-grid">
        {Object.entries(packages).map(([category, pkg]) => (
          <div
            key={category}
            className="package-card"
            style={{ borderTopColor: categoryColors[category] }}
          >
            <div className="package-header">
              <h3>{pkg.name}</h3>
              <span className="package-price">${pricingConfig.package_base_prices[category]}</span>
            </div>

            <div className="admin-form-group">
              <label>Package Name</label>
              <input
                type="text"
                className="admin-input"
                value={pkg.name}
                onChange={(e) => updatePackage(category, 'name', e.target.value)}
              />
            </div>

            <div className="admin-form-group">
              <label>Description</label>
              <input
                type="text"
                className="admin-input"
                value={pkg.description}
                onChange={(e) => updatePackage(category, 'description', e.target.value)}
              />
            </div>

            <div className="admin-form-group">
              <label>Oil Quarts Included</label>
              <input
                type="number"
                className="admin-input"
                value={pkg.oil_quarts_included}
                onChange={(e) => updatePackage(category, 'oil_quarts_included', parseInt(e.target.value))}
              />
            </div>

            <div className="admin-form-group">
              <label>Included Items</label>
              <div className="includes-list">
                {pkg.includes.map((item, index) => (
                  <div key={index} className="include-item">
                    <input
                      type="text"
                      className="admin-input"
                      value={item}
                      onChange={(e) => updateInclude(category, index, e.target.value)}
                    />
                    <button
                      type="button"
                      className="remove-btn"
                      onClick={() => removeInclude(category, index)}
                      title="Remove item"
                    >
                      &times;
                    </button>
                  </div>
                ))}
                <button
                  type="button"
                  className="admin-btn admin-btn-secondary add-btn"
                  onClick={() => addInclude(category)}
                >
                  + Add Item
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <style>{`
        .unsaved-banner {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1rem 1.5rem;
          background: #fef3c7;
          border: 1px solid #f59e0b;
          border-radius: 8px;
          margin-bottom: 1.5rem;
          color: #92400e;
          font-weight: 500;
        }

        .packages-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
          gap: 1.5rem;
        }

        .package-card {
          background: white;
          border-radius: 12px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          padding: 1.5rem;
          border-top: 4px solid;
        }

        .package-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1.5rem;
          padding-bottom: 1rem;
          border-bottom: 1px solid #e5e7eb;
        }

        .package-header h3 {
          margin: 0;
          font-size: 1.25rem;
        }

        .package-price {
          font-size: 1.5rem;
          font-weight: 700;
          color: #111827;
        }

        .includes-list {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }

        .include-item {
          display: flex;
          gap: 0.5rem;
        }

        .include-item .admin-input {
          flex: 1;
        }

        .remove-btn {
          width: 36px;
          height: 36px;
          border: 1px solid #fecaca;
          background: #fef2f2;
          color: #dc2626;
          border-radius: 8px;
          cursor: pointer;
          font-size: 1.25rem;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s;
        }

        .remove-btn:hover {
          background: #fee2e2;
        }

        .add-btn {
          margin-top: 0.5rem;
        }
      `}</style>
    </div>
  );
}

export default PackageManager;
